import { parseQueryString } from "@client/lib/api";
import { type Unsubscribe } from "./types";

export const getTypeFromQS = (): "instant" | "default" => {
  const qs = parseQueryString(window.location.href);
  return (qs ? qs["t"] : undefined) ?? "default";
};

export const getSidFromQS = (): string | undefined => {
  const qs = parseQueryString(window.location.href);
  return qs ? qs["sid"] || qs["s"] : undefined;
};

export const getEmailFromQS = (): string | undefined => {
  const qs = parseQueryString(window.location.href);
  return qs ? qs["e"] || qs["email"] : undefined;
};

export const getActionFromQS = (): Unsubscribe.UnsubscribeAction | undefined => {
  const qs = parseQueryString(window.location.href);
  const p = qs ? qs["p"] : undefined;
  if (!p) return;

  switch (p) {
    case "global":
      return "all";
    case "list":
      return "list";
    default:
      return;
  }
};
